import Modal from "./modal";
import $ from 'jquery';

export default class UrlModal extends Modal {
    constructor(url) {
        super();
        this.url = url;
    }

    getContent() {
        return new Promise((resolve, reject) => {
            $.ajax({url: this.url}).done((responseText) => {
                let selector = 'body';
                //from jquery .load src
                let content = $("<div>").content.append(responseText).find(selector);
                //for some reason body can disappear from jquery element content
                //and content in this case is empty
                //check this if url modal will be used
                resolve(content);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/modal/js/url-modal.js